import { render, staticRenderFns } from "./TheRouter.vue?vue&type=template&id=665b2182&scoped=true"
import script from "./TheRouter.vue?vue&type=script&lang=js"
export * from "./TheRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b2182",
  null
  
)

export default component.exports